import { Injectable, signal } from "@angular/core";
import { BehaviorSubject, firstValueFrom, lastValueFrom, map, of, Subject, Subscription } from "rxjs";
import { ApiService } from "src/app/common/services/api.service";
import { environment } from "src/environments/environment";
import { ActivatedRoute } from "@angular/router";
import { GlobalContants } from "src/app/common/constants/global.contants";
import { SharedService } from "src/app/common/services/shared.service";
import { ReportService } from "./report.service";
import { ReportsViewEnum } from '../models/enums/reports.enum';
import { apiEndPoints } from '../../common/constants/api-endpointsconstant';
import { TranslateService } from "@ngx-translate/core";
import { DecimalPipe } from "@angular/common";
import * as pako from 'pako';
import { Buffer } from 'buffer';
import { CATEGORY_GROUP_NAMES, categoryGrops, layerConstant } from "src/app/common/constants/layer-constant";
import { StoreService } from "src/app/common/services/store.service";
import { actionIdConstants, countryCode } from "src/app/common/constants/common.contants";
import { UserService } from "src/app/common/services/user.service";
import { activityPayload } from "src/app/common/models/userActivity.model";

@Injectable({
  providedIn: "root"
})
export class ReportMapService {
  public mapObject:any;
  public zoom = new BehaviorSubject<number>(10);
  public mapZoom = this.zoom.asObservable();
  public tenantDataState$ = new BehaviorSubject<any>('');
  public tenantName = signal('')
  public selectedIndex = signal('-1')
  public mapCurrentMapState = signal('');
  public mapCurrentMapStateZoom = signal(0);
  public updateTenentBounds$ = new Subject<boolean>();
  public mapLayertoggle = new Subject<boolean>();
  public mapLayer_current = signal<any>('default');
  public mapLayerSwitcher = new Subject<string>();
  public reportFiltertoggle = new Subject<any>();
  public mapFiltertoggle = new Subject<boolean>();
  public propertyinfotoggle = new Subject<boolean>();
  public basemapLayer = new Subject<string>();
  public legendLayer = new Subject<any>();
  public resetMarker = new Subject<any>();
  public legendLayerGroup = new Subject<any>();
  public legendLayerGroupList = new BehaviorSubject<any>('');
  public toggleCluster$ = new Subject<any>();
  public islumsumCluster$ = signal<any>('');
  public legendToggle = new Subject<boolean>();
  public drawPolyToggle = new Subject<boolean>();
  public mapFullscreenToggle = new Subject<boolean>();
  public reportFilter = new Subject<any>();
  public transaction_LayerActive = new Subject<boolean>();
  public mapCentroid: any = null;
  public mapCoordinates: any = new Subject<any>();
  public dashboardMapCoordinates: any = new Subject<any>();
  public overlay_mapLayer = new Subject<any>();
  public overlay_mapLayerEvent$ = new Subject<any>();
  public overlay_mapLayer_selected = new Subject<any>();
  public overlay_mapLayer_current = signal<any>('');
  public currentLegendState = signal<any>('');
  public selected_propertydetails = new Subject<any>();
  public appliedFilter = new Subject<any>();
  public amenitiesItemList = new Subject<any>();
  public streetNameList = new Subject<any>();
  activeRoute$: Subscription = new Subscription();
  public universalSearchtoggle = new Subject<boolean>();
  placeCode: any;
  public mapInstance: any;
  public mobile: boolean = false;
  propertyAttributes: any = [];
  public base64regex = /^([0-9a-zA-Z+/]{4})*(([0-9a-zA-Z+/]{2}==)|([0-9a-zA-Z+/]{3}=))?$/;
  private rand_array = ['s', 'e', '4', 'z', 'x', 'f', 'a', 'k', 'l', 'y', 'n', '6', '1'];
  keys: string = environment.encrypt_key;
  constructor(private apiServive: ApiService, private activatedRoute: ActivatedRoute, private sharedService: SharedService
    , private translate: TranslateService, public reportService: ReportService,
    private decimalPipe: DecimalPipe,
  private storeService: StoreService, private userService: UserService) {
    this.placeCode = this.sharedService.getStoreValue(GlobalContants.StoreKey.placeCode);
   
    // if(this.placeCode){
    //   this.getAllowedAttributes();
    // }
    // this.sharedService.selectedCity$.subscribe(res=>{
    //   this.placeCode = this.sharedService.getStoreValue(GlobalContants.StoreKey.placeCode);
    //   this.getAllowedAttributes();
    // })
  }

  /**
   * This is a function to use get allow attribute list of property
   */
  // getAllowedAttributes() {
  //   this.apiServive.get(`${environment.miBaseUrl}${apiEndPoints.userSettings}?status=1&search_text=available_map_attributes`).subscribe(
  //     {
  //       next: (res: any) => {
  //         if(res.status == 200 && res.data?.length>0 && res.data[0]){
  //           let att = res.data[0];
  //           this.propertyAttributes = att.value ? (att.value && att.value.split(',')) : [];
  //         }
  //       },
  //       error: (err) => {

  //       }
  //     }
  //   )
  // }
  public setZoom(zoom: number): void {
    this.zoom.next(zoom);
  }

  public setCentroid(value: any) {
    this.mapCentroid = value;
  }
  public getCentroid() {
    return this.mapCentroid;
  }
  public getLegendcolor() {
    let color_list = ["#800026", "#E31A1C", "#FEB24C", "#FEB24C", "#FED976"];
    return color_list;
  }

  public getLayerData() {
    let layer_data: any =
    {
      "sort_order": "1",
      "layer_name": "property_details",
      "store_name": "MI",
      "layer_type": "wms-pbf",
      "popup_exclude": ["lat", "lon", "wkt", "property_name", "property_uid"],
      "legend": [{ "legend": "max_unit_area", "label": "Land Area", "type": "number", "data": ["0", "200", "500", "1000"], "display": true },
      { "legend": "unit_category", "label": "Unit Type", "type": "like", "data": ["apartment", "office", "retail", "house"], "display": false },
      {
        "legend": "property_category", "label": "Category", "type": "like", "data": ["club", "retail", "government", "education", "health", "compound",
          "multi_story", "villa", "centers", "parking"], "display": false
      },
      { "legend": "property_grade", "label": "Grade", "type": "equals", "data": ["grade_a+", "grade_a", "grade_b", "grade_c", "grade_d"], "display": false }],
      "filter": [{ "name": "max_unit_area", "type": "number" }, { "name": "unit_category", "type": "like" },
      { "name": "unit_type", "type": "like" }, { "name": "property_category", "type": "like" },
      { "name": "neigh_name", "type": "equals" }, { "name": "property_name", "type": "equals" },
      { "name": "furnishing_status", "type": "equals" }, { "name": "property_grade", "type": "equals" },
      { "name": "setback", "type": "number" }, { "name": "frontage", "type": "number" },
      { "name": "street_name", "type": "equals" }, { "name": "furnishing_status", "type": "equals" },
      { "name": "corner", "type": "equals" }, { "name": "zoning", "type": "equals" },
      { "name": "transaction_value", "type": "number" }, { "name": "property_age", "type": "number" },
      { "name": "monthly_rent", "type": "number" }, { "name": "record_type", "type": "equals" },
      { "name": "lease_price", "type": "number" }, { "name": "year", "type": "equals" }],
      "map_layers": [{ "label": "Block", "layer_name": "blocks", "store_name": "gisdb", "color": "FFA500", "display": false, "type": "wms" },
      { "label": "Roads", "layer_name": "road_poly", "store_name": "gisdb", "color": "808080", "display": false, "type": "wms" },
      { "label": "Parcel", "layer_name": "gisdb:allparcels", "store_name": "gisdb", "color": "FF5733", "display": false, "type": "wms" },
      { "label": "Project", "layer_name": "project_layer", "store_name": "gisdb", "color": "EE7435", "display": false, "type": "pbf", "maxZoom": 25, "minZoom": 16 },
      { "label": "Metro", "layer_name": "metro_layer", "store_name": "gisdb", "color": "0000FF", "display": false, "type": "wms" },
      { "label": "Neighbourhood", "layer_name": "neighbourhoods", "store_name": "gisdb", "color": "5A5A5A", "display": false, "type": "pbf", "maxZoom": 15, "minZoom": 10 }]
    };
    return layer_data;
  }

  getReportCount(polygon?: any, isLumSum: boolean=false) {
    let queryParams = {}
    this.activeRoute$ = this.activatedRoute.queryParams.subscribe((params) => {
      queryParams = params;
      // this.tenantName.set('')
      this.tenantDataState$.next('');
    })
    let neigh_name = null, property_category = null, unit_category = null, year: any = null;

    // let filter: any = {...this.activatedRoute.snapshot.queryParams};
    let filter: any = queryParams;

    let filterObj = this.reportService?.getCurrentReport()?.filter; /// To fetch reports Filter Object
    let report_id = null;
    if (filter?.year) {
      year = this.reportService.yearMaxValue(filter?.year);
    } else {
      year = (filter?.transaction_date) ? this.reportService.getTTMmaxYear(filter?.transaction_date) : new Date().getFullYear();
    }
    //If Report Filter has map_filter = 'none' then report filter should not be applicable for the map data count to make the map data parcels and count in sync
    // Array.isArray(filterObj) && filterObj?.forEach((r: any) => {
    //   if (Object.keys(filter).filter((val: any) => val == r.col_name).length > 0) {
    //     if (r.map_filter == 'none') filter = Object.keys(filter).filter(objKey => objKey !== r.col_name).reduce((newObj: any, key) => {
    //       newObj[key] = filter[key];
    //       return newObj;
    //     }, {});
    //   }
    // })
    // Array.isArray(filterObj) && filterObj?.forEach((r: any) => {
    //   if (Object.keys(filter).filter((val: any) => val == r.col_name).length > 0) {
    //     if (r.map_filter == 'none') filter = Object.keys(filter).filter(objKey => objKey !== r.col_name).reduce((newObj: any, key) => {
    //       newObj[key] = filter[key];
    //       return newObj;
    //     }, {});
    //   }
    // })
    if (filter.rid) {
      report_id = filter.rid;
    }
    if (filter.oid)
      filter = Object.keys(filter).filter(objKey => objKey !== "oid").reduce((newObj: any, key) => {
        newObj[key] = filter[key];
        return newObj;
      }, {});
    if (filter.rid)
      filter = Object.keys(filter).filter(objKey => objKey !== "rid").reduce((newObj: any, key) => {
        newObj[key] = filter[key];
        return newObj;
      }, {});
    if (filter.gid)
      filter = Object.keys(filter).filter(objKey => objKey !== "gid").reduce((newObj: any, key) => {
        newObj[key] = filter[key];
        return newObj;
      }, {});
    if (filter.Centroid)
      filter = Object.keys(filter).filter(objKey => objKey !== "Centroid").reduce((newObj: any, key) => {
        newObj[key] = filter[key];
        return newObj;
      }, {});
    if (filter.Zoom)
      filter = Object.keys(filter).filter(objKey => objKey !== "Zoom").reduce((newObj: any, key) => {
        newObj[key] = filter[key];
        return newObj;
      }, {});
    if (filter.neigh_name) {
      neigh_name = filter.neigh_name;
      filter = Object.keys(filter).filter(objKey => objKey !== "neigh_name").reduce((newObj: any, key) => {
        newObj[key] = filter[key];
        return newObj;
      }, {});
    }
    if (filter.property_category) {
      property_category = filter.property_category;
      filter = Object.keys(filter).filter(objKey => objKey !== "property_category").reduce((newObj: any, key) => {
        newObj[key] = filter[key];
        return newObj;
      }, {});
    }
    if (filter.unit_category) {
      unit_category = filter.unit_category;
      filter = Object.keys(filter).filter(objKey => objKey !== "unit_category").reduce((newObj: any, key) => {
        newObj[key] = filter[key];
        return newObj;
      }, {});
    }

    // if (polygon && polygon.length > 1) {
    //   filter["polygon"] = polygon;
    //   neigh_name = null;
    // }

    if (filter.zoom)
      filter = Object.keys(filter).filter(objKey => objKey !== "zoom").reduce((newObj: any, key) => {
        newObj[key] = filter[key];
        return newObj;
      }, {});
    if (filter.centroid)
      filter = Object.keys(filter).filter(objKey => objKey !== "centroid").reduce((newObj: any, key) => {
        newObj[key] = filter[key];
        return newObj;
      }, {});
    if (filter.polygon) {
      filter = Object.keys(filter).filter(objKey => objKey !== "polygon").reduce((newObj: any, key) => {
        newObj[key] = filter[key];
        return newObj;
      }, {});
    }

    if (filter?.amenities) {
      this.amenitiesItemList.next(filter?.amenities);
      const items = filter.amenities.split(",");
      const resultArray = items.map((item: any) => {
        const parts = item.split("*");
        return {
          uid: parts[1],
          distance: parts[2]
        };
      });
      filter.amenities = resultArray;
    } else {
      this.amenitiesItemList.next(false);
    }

    if (filter?.street_name) {
      this.streetNameList.next(filter?.street_name);
      const items = filter.street_name.split(",");
      const resultArray = items.map((item: any) => {
        const parts = item.split("*");
        return {
          street_name: parts[0],
          distance: parts[1]
        };
      });
      filter.street_name = resultArray;
    } else {
      this.streetNameList.next(false);
    }
    filter.is_lumsum = ''+isLumSum || 'false';
    let url = `${environment.miUrl}${apiEndPoints.reportMapCluster}`;
    if (filter) url += `?report_id=${report_id}&filter=${encodeURIComponent(JSON.stringify(this.reportService.filterData(filter)).replace(/[+]/g, '%2B'))}`;
    if (polygon) {
      const polygonVal = JSON.parse(polygon)
      polygonVal.features = polygonVal.features?.map((data: any) => {
        return {
          type: data.type,
          properties: data.properties,
          geometry: data.geometry
        }
      })
      url += `&polygon=${JSON.stringify(polygonVal)}`;
      neigh_name = null;  //// If polygon is provided neighbourhood filter will be removed.
    }
    if (neigh_name && neigh_name.length > 1) url += `&neigh_name=${neigh_name}`;
    if (year) url += `&year=${year}`;
    if (property_category && property_category.length > 1) url += `&property_category=${property_category}`;
    if (unit_category && unit_category.length > 1) url += `&unit_category=${unit_category}`;

    return this.apiServive.get(url);
  }
  /**
   * create filter url
   * @param polygon
   * @returns
   */
  createFilterUrl(polygon: string) {
    let queryParams = {}
    this.activeRoute$ = this.activatedRoute.queryParams.subscribe((params) => {
      queryParams = params;
    })
    let neigh_name = null, property_category = null, unit_category = null, year: any = null;
    let filter: any = queryParams;

    let filterObj = this.reportService?.getCurrentReport()?.filter; /// To fetch reports Filter Object
    let report_id = null;
    if (filter?.year) {
      year = this.reportService.yearMaxValue(filter?.year);
    } else if (filter?.transaction_date) {
      year = this.reportService.getTTMmaxYear(filter?.transaction_date);
    }
    // Array.isArray(filterObj) && filterObj?.forEach((r: any) => {
    //   if (Object.keys(filter).filter((val: any) => val == r.col_name).length > 0) {
    //     if (r.map_filter == 'none') filter = Object.keys(filter).filter(objKey => objKey !== r.col_name).reduce((newObj: any, key) => {
    //       newObj[key] = filter[key];
    //       return newObj;
    //     }, {});
    //   }
    // })
    if (filter.rid) {
      report_id = filter.rid;
    }
    if (filter.oid)
      filter = Object.keys(filter).filter(objKey => objKey !== "oid").reduce((newObj: any, key) => {
        newObj[key] = filter[key];
        return newObj;
      }, {});
    if (filter.rid)
      filter = Object.keys(filter).filter(objKey => objKey !== "rid").reduce((newObj: any, key) => {
        newObj[key] = filter[key];
        return newObj;
      }, {});
    if (filter.gid)
      filter = Object.keys(filter).filter(objKey => objKey !== "gid").reduce((newObj: any, key) => {
        newObj[key] = filter[key];
        return newObj;
      }, {});
    if (filter.Centroid)
      filter = Object.keys(filter).filter(objKey => objKey !== "Centroid").reduce((newObj: any, key) => {
        newObj[key] = filter[key];
        return newObj;
      }, {});
    if (filter.Zoom)
      filter = Object.keys(filter).filter(objKey => objKey !== "Zoom").reduce((newObj: any, key) => {
        newObj[key] = filter[key];
        return newObj;
      }, {});
    if (filter.neigh_name) {
      neigh_name = filter.neigh_name;
      filter = Object.keys(filter).filter(objKey => objKey !== "neigh_name").reduce((newObj: any, key) => {
        newObj[key] = filter[key];
        return newObj;
      }, {});
    }
    if (filter.property_category) {
      property_category = filter.property_category;
      filter = Object.keys(filter).filter(objKey => objKey !== "property_category").reduce((newObj: any, key) => {
        newObj[key] = filter[key];
        return newObj;
      }, {});
    }
    if (filter.unit_category) {
      unit_category = filter.unit_category;
      filter = Object.keys(filter).filter(objKey => objKey !== "unit_category").reduce((newObj: any, key) => {
        newObj[key] = filter[key];
        return newObj;
      }, {});
    }

    if (filter.zoom)
      filter = Object.keys(filter).filter(objKey => objKey !== "zoom").reduce((newObj: any, key) => {
        newObj[key] = filter[key];
        return newObj;
      }, {});
    if (filter.centroid)
      filter = Object.keys(filter).filter(objKey => objKey !== "centroid").reduce((newObj: any, key) => {
        newObj[key] = filter[key];
        return newObj;
      }, {});
    if (filter.polygon) {
      filter = Object.keys(filter).filter(objKey => objKey !== "polygon").reduce((newObj: any, key) => {
        newObj[key] = filter[key];
        return newObj;
      }, {});
    }
    if (filter?.amenities) {
      const items = filter.amenities.split(",");
      const resultArray = items.map((item: any) => {
        const parts = item.split("*");
        return {
          uid: parts[1],
          distance: parts[2]
        };
      });
      filter.amenities = resultArray;
    }
    if (filter?.street_name) {
      filter.street_name = this.streetResultArray(filter.street_name);
    }

    let apiEndPoint = apiEndPoints.geoJsonPbfParcelLayerClickHouse;
    let url = `${environment.miUrl}${apiEndPoint}`;
    if (filter) url += `?report_id=${report_id}&filter=${encodeURIComponent(JSON.stringify(this.reportService.filterData(filter)).replace(/[+]/g, '%2B'))}`;
    if (polygon) {
      url += `&polygon=${polygon}`;
      // if(!zoom) neigh_name = null;  //// If polygon is provided neighbourhood filter will be removed.
    }
    if (neigh_name && neigh_name.length > 1) url += `&neigh_name=${neigh_name}`;
    if (year) url += `&year=${year}`;
    // if(zoom) url+= `&zoom=${zoom}`;
    if (property_category && property_category.length > 1) url += `&property_category=${property_category}`;
    if (unit_category && unit_category.length > 1) url += `&unit_category=${unit_category}`;
    return url;
  }
  streetResultArray(street_name: string): unknown {
    const items = street_name?.split(",");
    const resultArray = items.map((item: any) => {
      const parts = item.split("*");
      return {
        street_name: parts[0],
        distance: parts[1]
      };
    });
    return resultArray;
  }
  getGeoJsonPbfParcelLayerData(polygon: string) {
    const url = this.createFilterUrl(polygon)
    return this.apiServive.get(url);
  }

  async getMapLayer(city_code: string) {
    let url = `${environment?.estaterMapUrl}?city=${city_code}`;
    return await firstValueFrom(this.apiServive.get(url))
  //   .pipe(
  //   map((res: any) => res.data) 
  // );
  }
  getGeoJsonLayerData(polygon?: any, legend?: string, zoom?: any, isLumSum:boolean=false) {
    let queryParams = {}
    this.activeRoute$ = this.activatedRoute.queryParams.subscribe((params) => {
      queryParams = params;
    })
    let neigh_name = null, property_category = null, unit_category = null, year: any = null;

    // let filter: any = {...this.activatedRoute.snapshot.queryParams};
    let filter: any = queryParams;

    let filterObj = this.reportService?.getCurrentReport()?.filter; /// To fetch reports Filter Object
    let report_id = null;
    if (filter?.year) {
      year = this.reportService.yearMaxValue(filter?.year);
    } else if (filter?.transaction_date) {
      year = this.reportService.getTTMmaxYear(filter?.transaction_date);
    }
    // else{
    //   year = new Date().getFullYear();
    // }
    //If Report Filter has map_filter = 'none' then report filter should not be applicable for the map data count to make the map data parcels and count in sync
    // Array.isArray(filterObj) && filterObj?.forEach((r: any) => {
    //   if (Object.keys(filter).filter((val: any) => val == r.col_name).length > 0) {
    //     if (r.map_filter == 'none') filter = Object.keys(filter).filter(objKey => objKey !== r.col_name).reduce((newObj: any, key) => {
    //       newObj[key] = filter[key];
    //       return newObj;
    //     }, {});
    //   }
    // })
    // Array.isArray(filterObj) && filterObj?.forEach((r: any) => {
    //   if (Object.keys(filter).filter((val: any) => val == r.col_name).length > 0) {
    //     if (r.map_filter == 'none') filter = Object.keys(filter).filter(objKey => objKey !== r.col_name).reduce((newObj: any, key) => {
    //       newObj[key] = filter[key];
    //       return newObj;
    //     }, {});
    //   }
    // })
    if (filter.rid) {
      report_id = filter.rid;
    }
    if (filter.oid)
      filter = Object.keys(filter).filter(objKey => objKey !== "oid").reduce((newObj: any, key) => {
        newObj[key] = filter[key];
        return newObj;
      }, {});
    if (filter.rid)
      filter = Object.keys(filter).filter(objKey => objKey !== "rid").reduce((newObj: any, key) => {
        newObj[key] = filter[key];
        return newObj;
      }, {});
    if (filter.gid)
      filter = Object.keys(filter).filter(objKey => objKey !== "gid").reduce((newObj: any, key) => {
        newObj[key] = filter[key];
        return newObj;
      }, {});
    if (filter.Centroid)
      filter = Object.keys(filter).filter(objKey => objKey !== "Centroid").reduce((newObj: any, key) => {
        newObj[key] = filter[key];
        return newObj;
      }, {});
    if (filter.Zoom)
      filter = Object.keys(filter).filter(objKey => objKey !== "Zoom").reduce((newObj: any, key) => {
        newObj[key] = filter[key];
        return newObj;
      }, {});
    if (filter.neigh_name) {
      neigh_name = filter.neigh_name;
      filter = Object.keys(filter).filter(objKey => objKey !== "neigh_name").reduce((newObj: any, key) => {
        newObj[key] = filter[key];
        return newObj;
      }, {});
    }
    if (filter.property_category) {
      property_category = filter.property_category;
      filter = Object.keys(filter).filter(objKey => objKey !== "property_category").reduce((newObj: any, key) => {
        newObj[key] = filter[key];
        return newObj;
      }, {});
    }
    if (filter.unit_category) {
      unit_category = filter.unit_category;
      filter = Object.keys(filter).filter(objKey => objKey !== "unit_category").reduce((newObj: any, key) => {
        newObj[key] = filter[key];
        return newObj;
      }, {});
    }

    // if (polygon && polygon.length > 1) {
    //   filter["polygon"] = polygon;
    //   neigh_name = null;
    // }

    if (filter.zoom)
      filter = Object.keys(filter).filter(objKey => objKey !== "zoom").reduce((newObj: any, key) => {
        newObj[key] = filter[key];
        return newObj;
      }, {});
    if (filter.centroid)
      filter = Object.keys(filter).filter(objKey => objKey !== "centroid").reduce((newObj: any, key) => {
        newObj[key] = filter[key];
        return newObj;
      }, {});
    if (filter.polygon) {
      filter = Object.keys(filter).filter(objKey => objKey !== "polygon").reduce((newObj: any, key) => {
        newObj[key] = filter[key];
        return newObj;
      }, {});
    }
    if (filter?.amenities) {
      const items = filter.amenities.split(",");
      const resultArray = items.map((item: any) => {
        const parts = item.split("*");
        return {
          uid: parts[1],
          distance: parts[2]
        };
      });
      filter.amenities = resultArray;
    }
    if (filter?.street_name) {
      filter.street_name = this.streetResultArray(filter.street_name);
    }
    // let url =  `https://bi.dev10.in/clickhouse/fetchDataFilter`;//
    let apiEndPoint = environment.getLayer_from_clickHouse ? `${apiEndPoints.geoJsonParcelLayerClickHouse}` : `${apiEndPoints.geoJsonParcelLayer}`;
    let url = `${environment.miUrl}${apiEndPoint}`;
    if (filter) url += `?report_id=${report_id}&filter=${encodeURIComponent(JSON.stringify(this.reportService.filterData(filter)).replace(/[+]/g, '%2B'))}`;
    if (polygon) {
      url += `&polygon=${polygon}`;
      if (!zoom) neigh_name = null;  //// If polygon is provided neighbourhood filter will be removed.
    }
    if (neigh_name && neigh_name.length > 1) url += `&neigh_name=${neigh_name}`;
    if (year) url += `&year=${year}`;
    if (zoom) url += `&zoom=${zoom}`;
    url += `&isLumSum=${isLumSum}`;
    if (property_category && property_category.length > 1) url += `&property_category=${property_category}`;
    if (unit_category && unit_category.length > 1) url += `&unit_category=${unit_category}`;
    // return url;
    if (apiEndPoint == 'ch-parcel-layer') url += `&is_parcel_info=true`
    return this.apiServive.get(url);
  }

  getTransactionData() {
    let year = new Date().getFullYear();
    let url = `${environment.miUrl}${apiEndPoints.dashboardMapTransaction}?year=${year}`;
    return this.apiServive.get(url);
  }

  async getParcelInfo(uid: any, type: string = 'property', latlon:string[]=[]): Promise<any> {
    let queryParams = this.reportService.queryParams;
    let year = (queryParams?.year) ? this.reportService.yearMaxValue(queryParams.year.toString()) :
      (queryParams?.transaction_date) ? this.reportService.getTTMmaxYear(queryParams?.transaction_date) : new Date().getFullYear();
      let url: string = `${environment.miUrl}${apiEndPoints.mapDetailsPopup}?type=${type}&year=${year}`;
      if(latlon && latlon.length > 0){
        url += `&lat=${latlon[0]}&lon=${latlon[1]}`;
      } else {
        url += `&uid=${uid}`;
      }

    return lastValueFrom(this.apiServive.get(url));
  }
  createPoup(type: string, data: any, class_name = ''): string {
    let distance = data.distance / 1000;
    let kms = this.translate.instant('reports.km');
    // let subCat = (data.property_sub_cat?.split('"').map((item:string)=>item.charAt(0).toUpperCase() + item.slice(1)).join(', '))?.split('_').map((item:string)=>item.charAt(0).toUpperCase() + item.slice(1)).join(' ');
    let whitespace = (data.property_name && data.property_name?.length <= 20) ? 'whitespace' : 'min_width';
    // let footerContent = (subCat && subCat.length <= 21) ? `<span class="_cat oneline">${subCat}</span>`
    // : `<span class="_cat min_width_footer" title='${subCat}'>${subCat}</span>`;
    let property = `<div class="map-amenities-card">`;
    if (data.property_name) {
      property += `<div class="sub-header ${whitespace}"><span class="name_prorpert">${data.property_name} </span><span class="__distance">${distance} ${kms}</span></div>`;
    }
    // property += `<div class="card_footer">${footerContent} <span>${distance} ${kms}</span></div>
    `</div>`;
    return property;
  }
  resolveCategoryGroup(categoryString: string, country: string = '', isCategoryArray:boolean=false): string {
  const categories:any = isCategoryArray?categoryString:categoryString
    .split(',')
    .map(c => c.trim().toLowerCase());
  for (const group of categoryGrops) {
    if (group.condition(categories, country.toLowerCase())) {
      return group.name;
    }
  }

  return "other";
}
formatInternationNumNoDismal(num: any, digits: number = 0) {
    if (!num) {
      return '';
    }
    let ans: any = '';
    if (isNaN(num))
      return "Invalid Input"
    if (num >= 1000 && num <= 999999) {
      ans = this.decimalPipe.transform((num / 1000), '1.0-1') + this.translate.instant('thousand');
    } else if (num >= 1000000 && num <= 999999999) {
      ans = this.decimalPipe.transform((num / 1000000), '1.0-1') + this.translate.instant('million');
    } else if (num >= 1000000000 && num <= 999999999999) {
      ans = this.decimalPipe.transform((num / 1000000000), '1.0-1') + this.translate.instant('billion');
    } else {
      ans = this.decimalPipe.transform(num, '1.0-0') + ""
      if (ans.includes('.00')) ans = this.decimalPipe.transform((ans.split('.00')[0]), '1.0-0');
    }
    return ans;
  }
  /**
   * create transaction map cluster
   * @param data transaction data
   * @returns
   */
  transactionCluster(data: any, showRate: boolean = true, showRental:boolean=false, unit_sub_type:string='', numberFormated:boolean=false): string {
    let parcelClass = !showRate ? 'p_transaction_cluster' : '';
    let parnelClass = showRental ? 'p_rental_cluster' : '';
    let content = `<div class="transaction_cluster ${parcelClass} ${parnelClass}" dir="ltr">`;
    if (data.property_transaction_rate) {
      // const p_rate = (data.property_transaction_rate >= 1) ? this.decimalPipe.transform(data.property_transaction_rate, '1.0-0') : this.decimalPipe.transform(data.property_transaction_rate, '1.0-1');
      const p_rate = numberFormated? data.property_transaction_rate :(data.property_transaction_rate >= 1) ? this.formatInternationNumNoDismal(data.property_transaction_rate) : this.decimalPipe.transform(data.property_transaction_rate, '1.0-1');
      content += `
        <div class="transaction_cluster_rate">
          <span class="transaction_cluster_icon">
            <img src="assets/images/building.svg" />
          </span>
          <span class="transaction_cluster_val">${p_rate}</span>
        </div>`;
    }

    if (data.unit_transaction_rate) {
      // const u_rate = (data.unit_transaction_rate >= 1) ? this.decimalPipe.transform(data.unit_transaction_rate, '1.0-0') : this.decimalPipe.transform(data.unit_transaction_rate, '1.0-1');
      const u_rate = numberFormated? data.unit_transaction_rate :(data.unit_transaction_rate >= 1) ? this.formatInternationNumNoDismal(data.unit_transaction_rate) : this.decimalPipe.transform(data.unit_transaction_rate, '1.0-1');
      content += `
        <div class="transaction_cluster_rate">
          <span class="transaction_cluster_icon">
            ${unit_sub_type ?'<strong>'+ unit_sub_type + '</strong>':`<img src="assets/images/unit.svg" />`}
          </span>
          <span class="transaction_cluster_val">${u_rate}</span>
        </div>`;
    }

    content += `</div>`;
    return content;
  }
unitname(unit_sub_type:any) :string{
  if (unit_sub_type === 'studio') return 'STU'; 
  if (unit_sub_type === 'apartment') return 'APT'; 
  const match = unit_sub_type.match(/^(\d+(?:\.\d+)?)_bed/);
  if (match) {
    return `${match[1]}BD`; 
  }
  return unit_sub_type;  
}
  /**
   * Show the Report Type
   * @param value
   * @returns
   */
  reportType(value: any): string {
    if (value?.prop_type_estater == null || value?.prop_type_estater == 'null') {
      return '-'
    }
    if (value?.prop_type_govt && value?.prop_type_estater && value?.prop_type_govt !== value?.prop_type_estater) {
      return `<span><del>${this.translate.instant(value?.prop_type_govt)}</del></span><span class='reportType'>*${this.translate.instant(value?.prop_type_estater)}</span>`;
    } else if (value?.prop_type_govt) {
      return `<span>${this.translate.instant(value?.prop_type_govt)}</span>`;

    } else if (value?.prop_type_estater) {
      return `<span>${this.translate.instant(value?.prop_type_estater)}</span>`;

    } else {
      return '-'
    }
  }


  createPropertyTitle(properties:any, languageID=1){
      let cityCode = this.storeService.get(GlobalContants.StoreKey.placeCode);
      const isSaudi = this.sharedService.getStoreValue(GlobalContants.StoreKey.countryCode) === countryCode.saudi;
      if (isSaudi) cityCode = countryCode.saudi;

      const propertyNameLabel = this.translate.instant('property_name');
      const projectNameLabel = this.translate.instant('proj_name');
      const paciLabel = this.translate.instant('PACI No');
      const neighborhoodLabel = this.translate.instant('neigh_name');
      const planLabel = this.translate.instant('reports.plan_number');
      const parcelLabel = this.translate.instant('reports.parcelNumber');
      if (properties.proj_name) {
        const parseLangValue = (jsonStr: string | object) => {
        try {
          const parsed = typeof jsonStr === 'string' ? JSON.parse(jsonStr) : jsonStr;
          return parsed?.[languageID] || parsed?.[1];
        } catch {
          return '';
        }
      };
        return { header1: projectNameLabel, header2: parseLangValue(properties.proj_name) };
      }
      if (properties.property_name) {
        return { header1: propertyNameLabel, header2: properties.property_name };
      }

      let label = parcelLabel;
      let value = properties.parcel_no;

      if (cityCode === 'SA') {
        label = planLabel;
        value = properties.plan_no ?? properties.parcel_no;
      } else if (cityCode === 'KWT') {
        label = paciLabel;
        value = properties.ref_no;
      }

      if (label && value) {
        return { header1: label, header2: value };
      }

      if (properties.property_uid) {
        return { header1: propertyNameLabel, header2: properties.property_uid };
      }

      const parseLangValue = (jsonStr: string | object) => {
        try {
          const parsed = typeof jsonStr === 'string' ? JSON.parse(jsonStr) : jsonStr;
          return parsed?.[languageID] ?? parsed?.[1] ?? '';
        } catch {
          return '';
        }
      };
      if (properties.neigh_name) {
        return { header1: neighborhoodLabel, header2: parseLangValue(properties.neigh_name) };
      }

      return { header1: null, header2: null };

  }

  popup_content(type: string, propertiesdata: any, allowedAttributes: any, btn_label?: any, tenantData: any = '', className?: string, columnName?: string) {
    // let dupicateKey: any = [];
    // console.log(type, "type");

    let properties = { ...propertiesdata }
    if (type == 'property') {
      properties = { ...properties, record_type: '' }
    }
    // let accessAttributes = allowedAttributes ? allowedAttributes.map((str: any) => str.split(','))[0] : '';
    let current_langID = this.sharedService.getStoreValue(GlobalContants.StoreKey.CurrentLangID);
     if (type == 'tenant') {
      properties = {
        neigh_name: propertiesdata.neigh_name,
        land_area: propertiesdata.land_area,
        gla: propertiesdata.gla,
        total_shop: propertiesdata.total_shop,
        is_layout: propertiesdata.is_layout,
        occupancy: propertiesdata.occupancy,
        blended_lease_rate: propertiesdata.blended_lease_rate,
        lat: propertiesdata.lat,
        lon: propertiesdata.lon,
        property_uid: propertiesdata.property_uid,
        shop_name: propertiesdata.shop_name,
        shop_label: propertiesdata.shop_label,
        property_name: propertiesdata.property_name
      };
    }
    let content = document.createElement("div");
    const img = type === 'tenant'
      ? '../../../../assets/images/store.svg'
      : '../../../../assets/images/house.svg';

      let title = this.createPropertyTitle(properties,current_langID);
      let header1 = title?.header1;
      let header2 = title?.header2;
    content.classList.add('ol-popop');
    content.innerHTML = `
      <div class="popup-header">
        <img src="${img}" style="margin:5px; padding:4px; width:32px;" />
        <div class="directionLtr">
          <h6 class="sub-header">${header1}</h6>
          <h6 class="sub-value" title="${header2}">${header2}</h6>
        </div>
      </div>
      <hr style="background: #EAEAEA; width: 100%; position: relative; opacity: 0.2; margin-bottom: 5px;">
    `;
    
    // create close button
    let close_btn: any = document.createElement("div");
    close_btn.innerHTML = `<svg _ngcontent-ng-c1055677046="" xmlns="http://www.w3.org/2000/svg" width="10" height="10" viewBox="0 0 492 492"><path _ngcontent-ng-c1055677046="" fill="#8f8f8f" d="M300.188 246 484.14 62.04c5.06-5.064 7.852-11.82 7.86-19.024 0-7.208-2.792-13.972-7.86-19.028L468.02 7.872C462.952 2.796 456.196.016 448.984.016c-7.2 0-13.956 2.78-19.024 7.856L246.008 191.82 62.048 7.872C56.988 2.796 50.228.016 43.02.016c-7.2 0-13.96 2.78-19.02 7.856L7.872 23.988c-10.496 10.496-10.496 27.568 0 38.052L191.828 246 7.872 429.952C2.808 435.024.02 441.78.02 448.984c 0 7.204 2.788 13.96 7.852 19.028l16.124 16.116c5.06 5.072 11.824 7.856 19.02 7.856 7.208 0 13.968-2.784 19.028-7.856l183.96-183.952 183.952 183.952c5.068 5.072 11.824 7.856 19.024 7.856h.008c7.204 0 13.96-2.784 19.028-7.856l16.12-16.116c5.06-5.064 7.852-11.824 7.852-19.028 0-7.204-2.792-13.96-7.852-19.028L300.188 246z"></path></svg>`
    close_btn.classList.add('close-icon');
    content.append(close_btn);
    // on close
    close_btn.onclick = async (e: any) => {
        this.mapObject.closePopup();
    }

    let LockReport = this.reportService.getLockReport();

    let actionbtn = document.createElement("div");
    actionbtn.style.display = "flex";
    actionbtn.style.justifyContent = "end";
   

    if (type == "transaction" || type == "property" || type == 'project' || type == 'tenant') {
      let btn_content: any = document.createElement("button");
      btn_content.innerHTML = this.translate.instant('explore_property')//`Explore property`;
      if (btn_label?.length > 1) btn_content.innerHTML = this.translate.instant(`explore_${btn_label}`);
      btn_content.classList.add('explore-btn');
      if (LockReport) {
        let lockicon = document.createElement("img");
        lockicon.src = 'assets/images/Lock-disable.png'
        lockicon.classList.add('lock')
        btn_content.appendChild(lockicon);
        btn_content.disabled = true;
      }
      actionbtn.appendChild(btn_content);
      content.append(actionbtn);
      btn_content.onclick = async (e: any) => {
        //  this.reportService.transactionPropertyDetails.next(false);//close property detail if open
         setTimeout(() => {
           this.reportService.reportView$.next(ReportsViewEnum.mapGridView);
        this.reportService.isDetailPageOpen = true;
        if (type == 'property' && properties?.is_layout) {
          this.getFloorData(properties, e);
          return;
        }
        if (type == 'tenant') {
          // this.reportService.reportView$.next(ReportsViewEnum.mapGridView);
          this.reportService.showTenantMap$.next(properties);
        } else {
          this.reportService.showTenantMap$.next(false);
        }
        if (type == 'tenant') {
          setTimeout(() => { this.tenantDataState$.next(tenantData) }, 500)
          this.reportService.showTenantMap$.next(properties);
          this.reportService.showTenantPrevPropertyMap$.set(properties);
          this.updateTenentBounds$.next(true)
        } else {
          this.reportService.showTenantMap$.next(false);
          this.tenantDataState$.next('');
          this.updateTenentBounds$.next(false)
        }
        //
        let queryParam: any = [];
        queryParam = this.reportService.queryParams;
        let parems_p_cat = (queryParam['property_category']) ? queryParam['property_category'].toLowerCase() : null;
        let data_p_cat = (properties?.property_category) ? properties.property_category.toLowerCase() : null;
        if (data_p_cat == 'multi_story_residential' && parems_p_cat?.includes('multi_story_residential')) {
          this.reportService.multi_story_residential$$.set(true)
        } else this.reportService.multi_story_residential$$.set(false)
        this.propertyinfotoggle.next(true);
        this.selected_propertydetails.next(properties);
       
        const actionMap: Record<string, number> = {
        property: actionIdConstants.explore_property,
        project: actionIdConstants.explore_project,
        neighbourhoods: actionIdConstants.explore_neighbourhood
      };
        try {
          if (properties?.proj_name) {
            properties['proj_name'] = JSON.parse(properties?.proj_name);
          }
          if (properties?.neigh_name) {
            properties['neigh_name'] = JSON.parse(properties?.neigh_name)
          }
          
        } catch (error) {

        }
          const key = btn_label?.toLowerCase();
          const activity: activityPayload = {
            userdata: { properties: properties },
            actionId: actionMap[key] ?? actionIdConstants.explore_property,//actionIdConstants.explore_property,
            entity: 'report',
            entityId: this.activatedRoute.snapshot.queryParams['rid'],
          };
          this.userService.logUserActivity(activity);
         }, 800);
       
     }
    }

    return content;
  }

  async getFloorData(data: any, event: any) {
    console.log(data, "data explore button");

    event.target.classList.add('btn_loader');
    try {
      const propertyData: any = await this.getParcelInfo(data?.property_uid);
      if (propertyData.status == 200 && propertyData?.data?.length) {
        let properties = { ...propertyData.data[0], is_layout: data?.is_layout };
        this.propertyinfotoggle.next(true);
        this.selected_propertydetails.next(properties);
        this.reportService.showTenantMap$.next(properties);
      }
      event.target.classList.remove('btn_loader');
    } catch (error) {
      event.target.classList.remove('btn_loader');
      console.warn("Something went Wrong!, Try Again");
    }
  }
  getHousevillaLandInfo(queryParams: any) {
    if (queryParams?.year) queryParams.year = this.reportService.yearMaxValue(queryParams.year);
    const changeParams = this.reportService.setfilterQueryParams(queryParams);
    const url: string = `${environment.miUrl}${apiEndPoints.houseVillaLandInformation}${changeParams}`;
    return this.apiServive.get(url);
  }

  getHousevillaAreaInfo(queryParams: any) {
    if (queryParams?.year) queryParams.year = this.reportService.yearMaxValue(queryParams.year);
    const changeParams = this.reportService.setfilterQueryParams(queryParams);
    const url: string = `${environment.miUrl}${apiEndPoints.houseVillaAreaInformation}${changeParams}`;
    return this.apiServive.get(url);
  }

  public mixKey(str: string) {
    this.keys += this.keys + str;
  }

  public encryptKey(text: string) {
    var rand_index = Math.floor(Math.random() * 10);
    var rand_value = this.rand_array[rand_index];

    this.mixKey(text);
    var str_final_char = rand_value;
    rand_index++; // one increment to avoid zero index
    for (var i = 0; i < text.length; i++) {
      var str = text.substr(i, 1);
      var str_value = str.charCodeAt(0) - rand_index;
      var str_chr = String.fromCharCode(str_value);
      str_final_char += str_chr;

      var keychar = this.keys.substr(i, 1);
      var keychr_value = keychar.charCodeAt(0) - rand_index;
      var key_chr = String.fromCharCode(keychr_value);
      str_final_char += key_chr;
    }

    return window.btoa(str_final_char);
  }
  // public decodeAndDecompress = (encodedString: string): any => {
  //   // Decode Base64 to binary string
  //   const binaryString = atob(encodedString);
  //   // Convert binary string back to Uint8Array
  //   const byteArray = new Uint8Array(binaryString.length);
  //   for (let i = 0; i < binaryString.length; i++) {
  //       byteArray[i] = binaryString.charCodeAt(i);
  //   }

  //   // Decompress and parse JSON
  //   const decompressed = pako.inflate(byteArray, { to: 'string' });
  //   return JSON.parse(decompressed);
  // };
  public decodeAndDecompress = (compressedBase64: any) => {
    const compressedBuffer:any = Buffer.from(compressedBase64, "base64");
    const decompressed = pako.inflate(compressedBuffer, { to: "string" }); // Convert back to JSON string
    return JSON.parse(decompressed); // Parse back to object
  };
  public decryptKey(text: string) {
    if (this.base64regex.test(text) == false) {
      text = this.encryptKey(text);
    }
    var original_key = this.keys;
    var decoed_text = window.atob(text);  //method decodes a base-64 encoded string.// The atob() method decodes a base-64 encoded string. Note. The atob() method decodes a string that has been encoded by the btoa()
    var str_final_char = '';
    var key_final_char = '';
    // one increment to avoid zero index
    let rand_index: any;
    for (let i = 0; i < decoed_text.length; i++) {
      var str = decoed_text.substr(i, 1); // extracts a part of a string on given index
      if (i == 0) {
        rand_index = this.rand_array.indexOf(str); // get index of string in range_array
        rand_index++;
        continue;
      }

      if (i % 2 != 0) {
        var str_value = str.charCodeAt(0) + rand_index; // string charcode + range_index
        var str_chr = String.fromCharCode(str_value); // static method returns a string created from the specified sequence of UTF-16 code units.
        str_final_char += str_chr;
      } else {
        var keychr_value = str.charCodeAt(0) + rand_index;
        var key_chr = String.fromCharCode(keychr_value);
        key_final_char += key_chr;
      }
    }
    var keyOriginalLen = original_key.length; //10
    var keyleng = key_final_char.length; //5
    if (keyOriginalLen < keyleng) {
      for (let k = 0; k < original_key.length; k++) {
        if (original_key.substr(k, 1) != key_final_char.substr(k, 1)) {

          return null;
        }
      }
    } else {
      for (let k = 0; k < key_final_char.length; k++) {
        if (original_key.substr(k, 1) != key_final_char.substr(k, 1)) {
          return null;
        }
      }
    }
    return JSON.parse(str_final_char);
  }

  /**
   * popupOptions function to calcuate x/y position on map area
   * @param e event.target
   * @returns x,y
   */
  popupOptions(pixel: any, mapWidth: number, mapHeight: number) {
    let data = { class_name: '', x: 0, y: 0 }
    const pixelX = pixel[0];
    const pixelY = pixel[1];

    if (pixelY < 300) {
      data.class_name = 'topCenter';
      data.y = 55, data.x = 0;
    }
    if (pixelY < 300 && pixelX < 130) {
      data.class_name = 'topLeft';
      data.y = 15, data.x = 150;
    }
    if (pixelY >= 300 && pixelX < 130) {
      data.class_name = 'bottomLeft';
      data.y = 40, data.x = 150;
    }
    if (pixelY < 300 && pixelX > (mapWidth - 100)) {
      data.class_name = 'topRight';
      data.y = 20, data.x = -150;
    }
    if (pixelY >= 300 && pixelX > (mapWidth - 100)) {
      data.class_name = 'bottomRight';
      data.y = 40, data.x = -150;
    }
    
    return data;
  }
  /**
   * popupTooltipOptions function to calcuate x/y position on map area
   * @param e event.target
   * @returns x,y
   */
  popupTooltipOptions(e: any, mapWidth: number, mapHeight: number, content: any) {
    let nameLength = content?.property_name?.length || 0;
    let lineHeader = nameLength <= 21 ? 1 :
      nameLength <= 42 ? 2 :
        nameLength <= 63 ? 3 : 4;
    let lineFooter = (content.property_sub_cat && content.property_sub_cat?.length <= 20) ? 1 : 2;
    let data = { class_name: '', x: 0, y: 0 }
    if (e.containerPoint.y > (mapHeight - 180)) {
      data.y = -15, data.x = 0;
      if (e.containerPoint.x > (mapWidth - 125)) {
        data.y = -15, data.x = -108;
      }
      if (e.containerPoint.x < 125) {
        data.y = -15, data.x = 108;
      }
    } else {
      // let y = (lineHeader > 1 && lineFooter>1)? 95: (lineFooter>1)? 77:(lineHeader > 1)? 81: 65;
      let y = (lineHeader == 2) ? 81 :
        (lineHeader == 3) ? 95 :
          (lineHeader == 4) ? 109 : 65;

      data.y = y, data.x = 0;
      if (e.containerPoint.x > (mapWidth - 125)) {
        data.y = y, data.x = -108;
      }
      if (e.containerPoint.x < 125) {
        data.y = y, data.x = 108;
      }

    }
    return data;
  }

  filterLegendData(data: any) {
    return data?.map((p: any) => {
      return {
        ...p,
        data: p.data.filter((item: any) => item.layer_status === true)
      };
    })
  }


  ngOnDestroy(): void {
    this.activeRoute$.unsubscribe();
  }
}
